<template>
  <div class="image-item"
  >
    <div class="image-thumbnail">
      <canvas ref="canvas" />
    </div>
    <div class="image-text-outer">
      <div class="image-text" :class="{
        success: successTag ? image[successTag] : image.success
      }">
        <template v-if="successTag ? image[successTag] : image.success">
          <svgCheckCircle />
        </template>
        <template v-else>
          <svgWarningCircle />
        </template>
        {{label}}
      </div>
      <div class="image-data" v-if="detailed">
        <div class="image-data-item" 
          v-for="value, i in detailKeys" 
          :key="i"
        >
          <span>{{value}}</span>
          <span>{{image[value]}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import svgCheckCircle from '@/svg/svgCheckCircle'
import svgWarningCircle from '@/svg/svgWarningCircle'

export default {
  props: [
    'image',
    'label',
    'successTag',
    'detailed',
    'baseImageUrl',
    'imageDimensions',
    'detailKeys'
  ],
  data() {
    return {
      
    }
  },
  watch: {
  },
  created() {
    
  },
  mounted() {
    this.drawOnCanvas()
  },
  methods: {
    drawOnCanvas() {
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      const img = new Image()
      img.onload = ()=> {
        // const imgWidth = this.imageDimensions.width
        // const imgHeight = this.imageDimensions.height
        
        const boxWidth = this.image.location.width && this.image.location.width > 0 ? this.image.location.width : this.image.location.height
        const boxHeight = this.image.location.height && this.image.location.height > 0 ? this.image.location.height : this.image.location.width
        
        const isLandscape = boxWidth >= boxHeight

        const boxBaseSize = isLandscape ? boxHeight : boxWidth

        // const heightRatioToWidth = boxHeight / boxWidth

        canvas.width = boxBaseSize
        canvas.height = boxBaseSize

        const offsetX = isLandscape ? ((boxWidth - boxHeight) * -0.5): 0
        const offsetY = !isLandscape ? ((boxHeight - boxWidth) * -0.5): 0

        ctx.drawImage(
          img,
          this.image.location.left, 
          this.image.location.top, 
          boxWidth, 
          boxHeight, 
          offsetX, 
          offsetY,
          isLandscape ? boxBaseSize * boxWidth/boxHeight : boxBaseSize,
          !isLandscape ? boxBaseSize * boxHeight/boxWidth : boxBaseSize
        )


        // console.log({
        //   img: img,
        //   top: this.image.location.top,
        //   left: this.image.location.left,
        //   width: this.image.location.width,
        //   height: this.image.location.height,
        //   boxWidth: boxWidth,
        //   boxHeight: boxHeight,
        //   offsetX: offsetX,
        //   offsetY: offsetY,
        //   dWidth: isLandscape ? boxBaseSize * boxWidth/boxHeight : boxBaseSize,
        //   dHeight: isLandscape ? boxBaseSize * boxHeight/boxWidth : boxBaseSize,
        //   isLandscape
        // })
        // // ctx.drawImage(img, this.image.location.left, this.image.location.top, boxWidth, boxHeight, offsetX, offsetY, boxWidth, boxHeight)
      }
      img.src = this.baseImageUrl
    }
  },
  computed: {
    imgStyle() {
      
      const imgWidth = this.imageDimensions.width
      const imgHeight = this.imageDimensions.height

      const width = (imgWidth)/(this.image.location.width ? this.image.location.width : this.image.location.height) * 100
      const height = imgHeight/this.image.location.height * 100

      const top = -1 * this.image.location.top/imgHeight * 100
      const left = -1 * this.image.location.left/imgWidth * 100

      return `
        width: ${width}%;
        height: ${height}%;
        transform: translate3d(${left}%, ${top}%, 0);
      `

    }
  },
  components: {
    svgCheckCircle,
    svgWarningCircle
  }
}
</script>

<style lang="scss" scoped>

.image-item {
  padding: 6px 8px;
  .detailed & {
    display: flex;
  }
}

.image-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 100%;
  border-radius: 10px;
  background-color: rgb(189, 189, 189);
  overflow: hidden;
  .detailed & {
    width: 100px;
    height: 100px;
    padding: 0;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.image-text-outer {
  .detailed & {
    margin-left: 10px;
    flex: 1;
  }
}



.image-text {
  display: flex;
  align-items: center;
  margin-top: 6px;
  color: #FC692A;
  font-weight: 700;
  font-size: var(--typ-body2);

  svg {
    margin-right :6px;
    display: block;
    width: 24px;
    height: auto;
  }

  &.success {
    color: #11BF88;
  }

  .detailed & {
    padding-bottom: 6px;
    margin: 0;
    border-bottom: 1px solid var(--gray-300);
  }
}

.image-data-item {
  font-weight: 700;
  font-size: var(--typ-body5);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 8px;
  span {
    display: inline-block;
    &:first-child {
      color: var(--gray-500);
      text-transform: capitalize;
    }
    color: var(--gray-900);
  }

}

</style>